import { useEffect } from 'react';

export default function usePopState() {
  useEffect(() => {
    const handler = () => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    };

    window.addEventListener('popstate', handler);

    return () => {
      window.removeEventListener('popstate', handler);
    };
  }, []);
}
